export const InnIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        id="Subtract"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.48267 1.25C6.48267 0.835786 6.81845 0.5 7.23267 0.5H11.7327C12.1469 0.5 12.4827 0.835786 12.4827 1.25C12.4827 1.66421 12.1469 2 11.7327 2H7.23267C6.81845 2 6.48267 1.66421 6.48267 1.25ZM12.0001 3H7.00008V4.97099C6.97907 5.00601 6.95906 5.04182 6.94008 5.07837L2.267 14.0784C1.57572 15.4097 2.54186 17 4.04199 17H14.5693C16.0426 17 17.0102 15.4612 16.3718 14.1334L12.0449 5.13341C12.0306 5.10372 12.0157 5.07449 12.0001 5.04573V3ZM5.43437 15.3H13.1072C13.8444 15.3 14.3282 14.5295 14.0078 13.8655L13.0429 11.8655C12.8761 11.5198 12.5261 11.3 12.1423 11.3H6.59223C6.23539 11.3 5.90558 11.4902 5.72679 11.799L4.56894 13.799C4.18299 14.4657 4.66404 15.3 5.43437 15.3Z"
        fill="#5E35EF"
      />
    </svg>
  );
};
